export default __webpack_public_path__ + "static/media/bl21.4219cf8c.png";